import { AlertCircle } from 'lucide-react';

interface AuthErrorBannerProps {
  error: string;
  onClear?: () => void;
}

export function AuthErrorBanner({ error, onClear }: AuthErrorBannerProps) {
  if (!error) return null;

  const handleChange = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <div 
      className="mb-6 p-4 bg-red-50 border border-red-100 rounded-lg flex items-start gap-3"
      onChange={handleChange}
    >
      <AlertCircle size={18} className="text-red-500 flex-shrink-0 mt-0.5" />
      <p className="text-sm text-red-700">{error}</p>
    </div>
  );
}
